import { API_URL, getToken, logout } from './auth'
import { appelerApi, lireErreur, ReseauError, SessionExpireeError } from './apiErrors'

interface OptionsRequete {
  method?: 'GET' | 'POST' | 'PATCH' | 'DELETE'
  corps?: unknown
  /** Par défaut : lectures publiques (sans jeton, donc cachables), écritures authentifiées. */
  authentifie?: boolean
}

/**
 * Appel à l'API Platform en JSON-LD. Lève une ApiError (réponse en erreur, violations de
 * validation), une SessionExpireeError (jeton absent ou refusé) ou une ReseauError.
 */
export async function requeteApi<T>(chemin: string, options: OptionsRequete = {}): Promise<T> {
  const { method = 'GET', corps, authentifie = method !== 'GET' } = options
  if (!API_URL) throw new ReseauError("L'adresse de l'API n'est pas configurée (VITE_API_URL).")

  const headers: Record<string, string> = { Accept: 'application/ld+json' }
  if (corps !== undefined) {
    headers['Content-Type'] = method === 'PATCH' ? 'application/merge-patch+json' : 'application/ld+json'
  }
  if (authentifie) {
    const token = getToken()
    if (!token) throw new SessionExpireeError()
    headers.Authorization = `Bearer ${token}`
  }

  const res = await appelerApi(`${API_URL}${chemin}`, {
    method,
    headers,
    body: corps === undefined ? undefined : JSON.stringify(corps),
  })
  if (res.status === 401 && authentifie) {
    logout()
    throw new SessionExpireeError()
  }
  if (!res.ok) throw await lireErreur(res)
  return (res.status === 204 ? undefined : await res.json()) as T
}
